import { Component, Inject, inject } from '@angular/core';
import { ButtonColor, DATA_SELECTOR_INJECTION_TOKEN, DialogSize } from '@aiwyn/shared';
import { ConfigService } from '@aiwyn/config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export enum SubmissionDialogStatus {
  INCOMPLETE = 'incomplete',
  SUCCESS = 'success',
  ERROR = 'error'
}

export interface ClientRequestSubmissionConfirmationDialogData {
  status: SubmissionDialogStatus;
}

@Component({
  selector: 'app-client-request-submission-confirmation-dialog',
  templateUrl: './client-request-submission-confirmation-dialog.component.html',
  styleUrls: ['./client-request-submission-confirmation-dialog.component.scss'],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'client-request-submission-confirmation-dialog',
    },
  ],
  standalone: false,
})
export class ClientRequestSubmissionConfirmationDialogComponent {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  readonly DialogSize = DialogSize;
  readonly SubmissionDialogStatus = SubmissionDialogStatus;

  title: string;
  message: string;
  primaryMessage: string;
  secondaryMessage: string;
  buttonText: string;
  showCancel: boolean;
  buttonColor: ButtonColor;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ClientRequestSubmissionConfirmationDialogData,
    private readonly dialogRef: MatDialogRef<ClientRequestSubmissionConfirmationDialogComponent>,
    private readonly configService: ConfigService,
  ) {
    this.updateDialogContent();
  }

  private updateDialogContent(): void {
    switch (this.data.status) {
      case SubmissionDialogStatus.SUCCESS:
        this.title = 'Documents Submitted Successfully';
        this.primaryMessage = 'Your documents have been successfully submitted.';
        this.secondaryMessage = 'Thank you for providing the requested information. You\'ll be notified if further action is required.';
        this.buttonText = 'Done';
        this.buttonColor = 'primary';
        this.showCancel = false;
        break;

      case SubmissionDialogStatus.ERROR:
        this.title = 'Something Went Wrong';
        this.primaryMessage = 'We couldn\'t submit your documents due to an error.';
        this.secondaryMessage = `Please check your internet connection and try again. If the issue persists, contact ${this.configService.customerName || '[Firm Name]'} for assistance.`;
        this.buttonText = 'Retry Submission';
        this.buttonColor = 'negative';
        this.showCancel = true;
        break;
    }
  }
}
